// Before adding a new URL to this file, please check
// if it is possible to disable it in config service
export const BANNED_URLS = [
  '/c/customer-service',
];
